import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationEN from './locales/en/translation.json';
import translationKO from './locales/ko/translation.json';
import translationJA from './locales/ja/translation.json';
import translationZHCN from './locales/zh-CN/translation.json';
import translationFR from './locales/fr/translation.json';
import translationES from './locales/es/translation.json';
import translationDE from './locales/de/translation.json';
import translationRU from './locales/ru/translation.json';

const resources = {
    en: {
        translation: translationEN
    },
    ko: {
        translation: translationKO
    },
    ja: {
        translation: translationJA
    },
    'zh-CN': {
        translation: translationZHCN
    },
    fr: {
        translation: translationFR
    },
    es: {
        translation: translationES
    },
    de: {
        translation: translationDE
    },
    ru: {
        translation: translationRU
    }
};

i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        fallbackLng: 'en',
        lng: localStorage.getItem('i18nextLng') || 'en',
        debug: process.env.NODE_ENV === 'development',

        interpolation: {
            escapeValue: false
        },

        // 브라우저 언어 감지
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng'
        },

        // 언어 변경시 localStorage에 저장
        react: {
            useSuspense: false,
            wait: true
        }
    });

export default i18n;